<template>
	<div class="container" id="ReportsOverview">
		<div v-if="page_loaded == 0" class="spinner">
			<i class="fas fa-spinner fa-spin fa-2x"></i>
		</div>
		<div v-else>
			<div class="text-center gold mt-4">
				<h3>
					Progress Overview:
					<router-link :to="'/dashboard/' + profile.id" class="">
						<small v-text="profile.user_name"></small>
					</router-link>
				</h3>
			</div>

			<div class="row m-3">
				<div class="col-md-5">
					<b-form-datepicker
						placeholder="Start Date"
						v-model="dates.start.selected"
						:min="dates.start.min"
						:max="dates.start.max"
					>
					</b-form-datepicker>
				</div>
				<div class="col-md-5">
					<b-form-datepicker
						placeholder="End Date"
						v-model="dates.end.selected"
						:min="dates.end.min"
						:max="dates.end.max"
					>
					</b-form-datepicker>
				</div>
				<div class="col-md-2">
					<b-button block variant="outline-primary" @click="date_refresh">
						Refresh <i class="fas fa-sync-alt"></i>
					</b-button>
				</div>
			</div>

			<div class="row gold m-4">
				<div class="col-sm-7 text-left">
					<h4>Weekly Averages</h4>
				</div>
				<div v-if="this.$store.getters.profileGetUserlevel >= 90" class="col-sm-5">
					<div class="row text-right">
						<div class="col pr-0">
							<router-link to="/reports_overview" class="btn btn-sm btn-outline-primary">
								<i class="fas fa-users"></i> Community Report
							</router-link>
						</div>
					</div>
				</div>
			</div>
			<div v-if="cards !== null">
				<div v-for="(card, k) in cards" :key="k" class="card mb-3 small">
					<div class="card-header">
						<div class="row">
							<div class="col-9 col-sm-10 col-lg-11 text-left">
								<small>Weekly data for</small>
								<b v-text="card.range" class="pl-1"></b>
							</div>
						</div>
					</div>
					<div class="row p-3 text-left">
						<div class="col-md-4 stats_wrapper">
							<h5>Meditation</h5>

							<table v-if="card.meditation" class="table table-sm">
								<thead>
									<tr class="small">
										<th scope="col" width="55%">Activity</th>
										<th scope="col"><span v-text="profile.user_name"></span></th>
										<th scope="col" class="text-right">Community</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											Sessions meditating
										</td>
										<td v-text="card.meditation.sessions" class="user"></td>
										<td v-text="card.meditation.sessions_comm_avg" class="community"></td>
									</tr>
									<tr>
										<td>
											Total time meditating <small>(h:m)</small>
										</td>
										<td v-text="card.meditation.time" class="user"></td>
										<td v-text="card.meditation.time_comm_avg" class="community"></td>
									</tr>
									<tr>
										<td>
											Avg. meditation time <small>(m)</small>
										</td>
										<td v-text="card.meditation.time_m_avg" class="user"></td>
										<td v-text="card.meditation.time_m_comm_avg" class="community"></td>
									</tr>
									<tr>
										<td>
											Wellbeing %
										</td>
										<td v-text="card.wellbeing.score" class="user"></td>
										<td v-text="card.wellbeing.score_comm_avg" class="community">-</td>
									</tr>

									<tr>
										<td>
											Daily Intention setting
										</td>
										<td v-text="card.misc.log" class="user"></td>
										<td v-text="card.misc.log_comm_avg" class="community">-</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div class="col-md-4 stats_wrapper">
							<h5>Sleep</h5>

							<table v-if="card.sleep" class="table table-sm">
								<thead>
									<tr class="small">
										<th scope="col" width="55%">Activity</th>
										<th scope="col"><span v-text="profile.user_name"></span></th>
										<th scope="col" class="text-right">Community</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											Sleep Score <small>%</small>
										</td>
										<td v-text="card.sleep.score.avg" class="user"></td>
										<td v-text="card.sleep.score.comm_avg" class="community"></td>
									</tr>
									<tr>
										<td>
											Sleep per day <small>(h:m)</small>
										</td>
										<td v-text="card.sleep.total.avg" class="user"></td>
										<td v-text="card.sleep.total.comm_avg" class="community"></td>
									</tr>
									<tr>
										<td>
											REM sleep per day <small>(h:m)</small>
										</td>
										<td v-text="card.sleep.rem.avg" class="user"></td>
										<td v-text="card.sleep.rem.comm_avg" class="community"></td>
									</tr>
									<tr>
										<td>
											Deep sleep per day <small>(h:m)</small>
										</td>
										<td v-text="card.sleep.deep.avg" class="user"></td>
										<td v-text="card.sleep.deep.comm_avg" class="community"></td>
									</tr>
								</tbody>
							</table>
						</div>

						<div class="col-md-4 stats_wrapper">
							<h5>Recovery</h5>

							<table v-if="card.body" class="table table-sm">
								<thead>
									<tr class="small">
										<th scope="col" width="55%">Activity</th>
										<th scope="col"><span v-text="profile.user_name"></span></th>
										<th scope="col" class="text-right">Community</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											Readiness Score <small>%</small>
										</td>
										<td v-text="card.body.readiness.avg" class="user"></td>
										<td v-text="card.body.readiness.comm_avg" class="community"></td>
									</tr>
									<tr>
										<td>
											Resting Heart Rate (RHR)
										</td>
										<td v-text="card.body.rhr.avg" class="user"></td>
										<td v-text="card.body.rhr_comm_avg" class="community"></td>
									</tr>
									<tr>
										<td>
											Heart rate variable (HRV)
										</td>
										<td v-text="card.body.hrv.avg" class="user"></td>
										<td v-text="card.body.hrv_comm_avg" class="community"></td>
									</tr>
									<tr>
										<td>
											Activity score <small>%</small>
										</td>
										<td v-text="card.activity.score.avg ?? 0" class="user"></td>
										<td v-text="card.activity.score.comm_avg ?? 0" class="community"></td>
									</tr>
									<tr>
										<td>
											How productive you felt <small>%</small>
										</td>
										<td v-text="card.meditation.productivity" class="user"></td>
										<td v-text="card.meditation.productivity_comm_avg" class="community"></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="spinner">
				<i class="fas fa-spinner fa-spin fa-2x"></i>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'ProfileReport',

	data() {
		const today = new Date().toISOString().slice(0, 10);
		/*let date = new Date();
			let month = new Date().getMonth();
			const startDate = new Date(date.setMonth(month - 2)).toISOString().slice(0,10);*/

		var now = new Date();
		var weeks = 6;
		var weeksAgo = weeks * 7;
		now.setDate(now.getDate() - weeksAgo);

		const startDate = now.toISOString().slice(0, 10);

		return {
			cards: null,
			chartdata: {},
			dates: {
				end: {
					min: null,
					max: today,
					selected: today,
				},
				start: {
					min: null,
					max: today,
					selected: startDate,
				},
			},
			page_loaded: 0,
			profile: {},
			yAxisSuggestedMax: 100,
		};
	},

	methods: {
		date_refresh() {
			this.cards = {};
			this.loadPageData();
		},

		loadPageData() {
			this.page_loaded = 0;
			this.profile_report_load();
			this.page_loaded = 1;
		},

		profile_report_load() {
			let _this = this;

			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('start_date', this.dates.start.selected);
			params.append('end_date', this.dates.end.selected);
			params.append('user_id', this.$route.params.user_id);

			axios({
				url: _this.$store.state.api_url + 'profileReport',
				params: params,
			})
				.then(function (response) {
					if (response.data.data) {
						_this.cards = response.data.data;
					}
					if (response.data.chartdata) {
						_this.chartdata = response.data.chartdata;
					}
					if (response.data.profile) {
						_this.profile = response.data.profile;
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		},
	},

	mounted() {
		this.loadPageData();
	},

	computed: {},
	watch: {},
};
</script>

<style scoped>
.spinner {
	text-align: center;
	margin: 2rem;
	color: #ccc;
}
.stats_wrapper {
	padding: 1rem;
	padding-top: 0;
	text-align: left;
}
.stats_wrapper .user {
	font-size: 0.9rem;
	color: #d1af60 !important;
	text-align: left;
	font-weight: bold;
}
.stats_wrapper .community {
	font-size: 0.8rem;
	color: #ccc !important;
	text-align: right;
}
</style>
